import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { X, Plus } from "lucide-react";
import OtherServicesModal from "../modals/OtherServicesModal";

interface AttachedFeeSidepanelProps {
  isOpen: boolean;
  onClose: () => void;
  onPay: () => void;
}

const AttachedFeeSidepanel: React.FC<AttachedFeeSidepanelProps> = ({
  isOpen,
  onClose,
  onPay,
}) => {
  const [isOtherServicesModalOpen, setIsOtherServicesModalOpen] =
    useState(false);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <OtherServicesModal
          isOpen={isOtherServicesModalOpen}
          onClose={() => setIsOtherServicesModalOpen(false)}
          onAddFee={(data) => {
            console.log("Added services:", data);
            // Handle added services
          }}
        />
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto  w-[369px]">
                  <div className="flex h-full flex-col overflow-y-scroll bg-[#F9FAFB] shadow-xl">
                    <div className="px-6 pt-8 pb-3 flex items-center justify-between">
                      <Dialog.Title className="text-lg font-bold text-[#101828]">
                        Attached fees
                      </Dialog.Title>
                    </div>

                    <div className="relative flex-1 px-6 pb-6 flex flex-col gap-y-6">
                      {/* Total Card */}
                      <div className="bg-white p-6 rounded-xl border border-[#E9EAEB] shadow-sm flex flex-col gap-y-1">
                        <span className="text-sm text-[#475467]">Total</span>
                        <span className="text-3xl font-bold text-[#027A48]">
                          N4,000.00
                        </span>
                      </div>

                      {/* Claimant letter A */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Claimant letter A
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Motion
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Oath
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Seal
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                      </div>

                      <div className="border-t border-dashed border-[#E9EAEB]"></div>

                      {/* Claimant letter B (Waived) */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Claimant letter B (Waived )
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Waived
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦0.00
                          </span>
                        </div>
                      </div>

                      <div className="border-t border-dashed border-[#E9EAEB]"></div>

                      {/* Claimant letter C */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Claimant letter C
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Motion
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Oath
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Seal
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                      </div>

                      <div className="border-t border-dashed border-[#E9EAEB]"></div>

                      {/* Other services */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Other services
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Seal
                          </span>
                          <span className="text-[#1A1A1A] font-bold">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3] font-medium">
                            Tax
                          </span>
                          <span className="text-[#1A1A1A] font-bold">₦t</span>
                        </div>
                      </div>

                      {/* Add other service button */}
                      <button
                        onClick={() => setIsOtherServicesModalOpen(true)}
                        className="w-full bg-[#E4E7EC] text-[#101828] py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors flex items-center justify-center gap-x-2 text-sm"
                      >
                        <Plus className="w-4 h-4" />
                        <span>Add other service</span>
                      </button>

                      <div className="mt-auto pt-4 flex flex-col gap-y-4">
                        <input
                          type="text"
                          placeholder="Payment title"
                          className="w-full p-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
                        />
                        <button
                          onClick={onPay}
                          className="w-full bg-[#00B074] text-white py-3 rounded-lg font-medium hover:bg-[#009b65] transition-colors"
                        >
                          Advise payment
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AttachedFeeSidepanel;
